import React from 'react';
import { RouterTabs } from 'ui/RouterTabs';
import { SalesMetrics } from './SalesMetrics/SalesMetrics';
import { CrmMetrics } from './CrmMetrics/CrmMetrics';
import { useSalesMetricsFiltersReducer } from './SalesMetrics/hooks/useSalesMetricsFiltersReducer';

interface ICrmDashboardTabProps {
  children: React.ReactNode;
  salesUserId?: string;
}

const CrmDashboardTab: React.FC<ICrmDashboardTabProps> = ({ children, salesUserId }) => {
  return <div className="w-full">{children}</div>;
}

interface ICrmDashboardTabsProps {
  salesUserId: string | undefined;
  dateFrom: string;
  dateTo: string;
}

export const CrmDashboardTabs: React.FC<ICrmDashboardTabsProps> = ({ salesUserId, dateFrom, dateTo }) => {
  const { filters, dispatchFilters } = useSalesMetricsFiltersReducer();

  const crmDashboardTabs = [
    {
      title: 'Sales Metrics',
      route: 'sales-metrics',
      styles: 'min-w-[50%]',
      renderContent: () => (
        <CrmDashboardTab salesUserId={salesUserId}>
          <SalesMetrics 
            salesUserId={salesUserId as string}
            dateFrom={dateFrom}
            dateTo={dateTo}
            filters={filters}
            dispatchFilters={dispatchFilters}
          />
        </CrmDashboardTab>
      ),
    },
    {
      title: 'CRM Metrics',
      route: 'crm-metrics',
      styles: 'min-w-[50%]',
      renderContent: () => (
        <CrmDashboardTab salesUserId={salesUserId}>
          <CrmMetrics
            salesUserId={salesUserId as string}
            dateFrom={dateFrom}
            dateTo={dateTo}
          />
        </CrmDashboardTab>
      ),
    },
  ];

  return <RouterTabs tabConfig={crmDashboardTabs} className="o:w-full o:p-0" routeContainerClassname="flex border border-solid border-gray-40 border-t-0 p-0 o:w-full" tabSelectorClassName="o:m-0" />;
};
